import { useRouteMatch, Switch, Route } from "react-router";
import MentalHealth from "./MentalHealth";
import MentalHealthManagement from "./MentalHealthManagement";
import MentalIllnessRegister from "./MentalIllnessRegister";
import MentalHealthIneligibleScreen from "./MentalHealthIneligibleScreen";
import IneligibleEatingDisorderScreen from "./IneligibleEatingDisorderScreen";
import { EligibilityCheckerQuestionsProps, EligibilityCheckerPageProps, ProgrammeProps } from "../Props";
import { HealthConditionDetails } from "../../../../types/ProfileViewModel";
import { PowerOfTen, ProgressStepEnum, setStepProgress } from "../../../../redux/slices/progressBarSlice";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

export interface MentalHealthPageData {
  questions: EligibilityCheckerQuestionsProps[];
  ineligibleScreens: {
    ineligibleMentalHealth: EligibilityCheckerPageProps;
    ineligibleEatingDisorder: EligibilityCheckerPageProps;
  };
}

export interface MentalHealthProps extends ProgrammeProps {
  mentalHealthPageData: MentalHealthPageData;
  nextStepUrl: string;
  healthConditions?: HealthConditionDetails;
}
const MentalHealthRoot = (props: MentalHealthProps & { progressPercentage?: PowerOfTen }) => {
  const { mentalHealthPageData, nextStepUrl, programmeTitle, healthConditions, progressPercentage } = props;
  let { path } = useRouteMatch();
  const dispatch = useDispatch();

  useEffect(() => {
    if (progressPercentage) {
      dispatch(
        setStepProgress({
          progressStepEnum: ProgressStepEnum.CheckEligiblity,
          progressPercentage: progressPercentage,
        })
      );
    }
  }, [dispatch, progressPercentage]);

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <MentalHealth
          healthConditions={healthConditions}
          mentalHealthPageData={mentalHealthPageData}
          programmeTitle={programmeTitle}
          nextStepUrl={nextStepUrl}
        />
      </Route>
      <Route exact path={`${path}/mental-health-management`}>
        <MentalHealthManagement mentalHealthPageData={mentalHealthPageData} programmeTitle={programmeTitle} />
      </Route>
      <Route exact path={`${path}/mental-illness-register`}>
        <MentalIllnessRegister
          mentalHealthPageData={mentalHealthPageData}
          programmeTitle={programmeTitle}
          nextStepUrl={nextStepUrl}
        />
      </Route>
      <Route exact path={`${path}/mental-health-management/fail`}>
        <MentalHealthIneligibleScreen
          mentalHealthPageData={mentalHealthPageData}
          programmeTitle={programmeTitle}
        />
      </Route>
      <Route exact path={`${path}/ineligible-eating-disorder/fail`}>
        <IneligibleEatingDisorderScreen
          mentalHealthPageData={mentalHealthPageData}
          programmeTitle={programmeTitle}
        />
      </Route>
    </Switch>
  );
};

export default MentalHealthRoot;
